import { render } from "./notPass.vue?vue&type=template&id=3d8b5d92&scoped=true"
import script from "./notPass.vue?vue&type=script&lang=js"
export * from "./notPass.vue?vue&type=script&lang=js"

import "./notPass.vue?vue&type=style&index=0&id=3d8b5d92&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8b5d92"]])

export default __exports__